import { render, staticRenderFns } from "./ClientProInformationModal.vue?vue&type=template&id=893df898"
import script from "./ClientProInformationModal.vue?vue&type=script&lang=js"
export * from "./ClientProInformationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports